import React from 'react';
import { ReactElement } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const AlertProvider = ({ children }) => {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {children}
    </>
  )
};

export const useAlerter = () => {
  const getPopOptions = (message: string) => ({
    autoClose: Math.max((message.length || 0) * 75, 5000),
    pauseOnHover: true
  });

  const getShowOptions = () => ({
    autoClose: false as false,
    pauseOnHover: true
  });

  const getErrorMessage = (err, action) => {
    if (typeof err === 'string' || React.isValidElement(err)) {
      return err;
    } else if (err.name === 'ValidationError') {
      return err.message;
    } else {
      console.log(err);
      return `Oops, failed to ${action} due to a system error.`
    }
  };

  const addError = (err, action, pop, options = {}) => {
    const message = getErrorMessage(err, action);
    toast.error(message, {
      ...(pop ? getPopOptions(message) : getShowOptions()),
      ...options
    });
  };

  const addSuccess = (message, pop, options = {}) => {
    toast.success(message, {
      ...(pop ? getPopOptions(message) : getShowOptions()),
      ...options
    });
  };

  return {
    toast,
    showError: (err: Error | string | ReactElement<any>, action: string = undefined, options: any = {}) => addError(err, action, false, options),
    popError: (err: Error | string | ReactElement<any>, action: string = undefined, options: any = {}) => addError(err, action, true, options),
    showSuccess: (message: string | ReactElement<any>, options: any = {}) => addSuccess(message, false, options),
    popSuccess: (message: string | ReactElement<any>, options: any = {}) => addSuccess(message, true, options)
  };
};
